module.exports = __webpack_public_path__ + "fonts/Play-Exchange-Icons.d32cc9b.woff";